import React from 'react'
import {
    Card,
    Image
} from "semantic-ui-react"

import site_icon from '../images/Faculty_icon/1.png'
import mail_icon from '../images/Faculty_icon/2.png'
import bag_icon from '../images/Faculty_icon/3.png'

const FacultyCard = ({image, faculty_name, education, description, email, website}) => {
    return (
        <Card id="faculty_card">
            <Image src={image} wrapped ui={false} />
            <Card.Content>
            <Card.Header text><Image size="mini" src={bag_icon}/>{faculty_name}</Card.Header>
            <Card.Meta>
                {education}
            </Card.Meta>
            <Card.Description>
                {description}
            </Card.Description>
            </Card.Content>
            <Card.Content extra>
                <Image as='a' href={"mailto:"+email} src={mail_icon} size="mini" target='_blank' rel="noreferrer"/>
                <Image as='a' href={website} src={site_icon} size="mini" target='_blank' rel="noreferrer"/>
            </Card.Content>
        </Card>
    )
}

export default FacultyCard